import RepositoryService from 'src/services/repository'

const resource = 'networkDiagram/instruction'

export default {
  getList: async () => {
    const response = await RepositoryService.base.get(`${resource}/`)
    return response?.data ?? response
  },
  patch: async data => {
    const response = await RepositoryService.base.patch(`${resource}/`, data)
    return response?.data ?? response
  },
  post: async file => {
    const formData = new FormData()
    formData.append('file', file)
    const response = await RepositoryService.base.post(`${resource}/`, formData, {
      'content-type': 'multipart/form-data',
    })
    return response?.data ?? response
  },
}
